// Estado visible de la pantalla actual, publicado por las páginas y leído por AriWidget.
// Permite al copiloto "saber lo que estás haciendo": errores en pantalla y campos vacíos.
let _estado = { errores_visibles: [], campos_vacios: [] };
const _subs = new Set();

export function setAriEstado(next) {
  _estado = { errores_visibles: [], campos_vacios: [], ...(next || {}) };
  _subs.forEach((f) => f());
}

export function clearAriEstado() {
  setAriEstado({});
}

export function getAriEstado() {
  return _estado;
}

export function subscribeAri(fn) {
  _subs.add(fn);
  return () => _subs.delete(fn);
}
